import Swiper from 'swiper';
import { getAuthToken, trackEvent } from "./helpers";
import { openDrawer, injectDataOnDrawer, closeDrawer } from "./components/drawer";

// API endoipoints
const ENDPOINTS = {
    qa_tips: 'api/v1/qea-tips',
    qa_drawer: 'api/v1/qea'
};
// key of the session storage for cache like
const CACHE_KEY = "qa_tips";

// on dom ready run fill banner logic
jQuery(async () => {
    try {
        const data = await getBannerQaContent();
        renderBanner(data);
    } catch (error) {
        console.error("Failed to load QA content:", error);
    }
});

function renderBanner(data) {
    const qaBanner = jQuery("#QA-banner");
    if(qaBanner.length) {
        qaBanner.find("#QA-title").text(data.title);
        const tips = data.tips_items || [];
        let sliderTips = `<div id="QA-swiper" class="swiper basic-carousel swiper-initialized swiper-horizontal swiper-backface-hidden" data-swiper-grab-cursor="true"><div class="swiper-wrapper">`;
        for (const t of tips) {
            sliderTips+=`
                <div class="swiper-slide">
                    <div class="flex flex-col gap-3 select-none">
                        <img width="24" height="24" src="${t?.icon?.url ?? '/themes/custom/adoption_management/assets/icons/light-faq.svg'}" alt="${t?.icon?.alt ?? 'icon'}">
                        <p class="font-normal text-base text-jumbo-950 ">${t?.text}</p>
                    </div>
                </div>
            `;
        }
        sliderTips+= "</div></div>";
        qaBanner.find("#QA-slider").html(sliderTips);
        const basicCarouselSettings = {
            slidesPerView: "auto",
            spaceBetween: 24,
            speed: 400,
            loop: false,
        };
        // activate the swiper library for slider
        const qaSwiper = new Swiper("#QA-swiper",basicCarouselSettings);
    } else {
        console.warn("QA-banner not found")
    }
}

async function getBannerQaContent() {
    const cached = sessionStorage.getItem(CACHE_KEY);
    // If we have cached data, return it immediately
    if (cached) {
        refreshQaTipsCache(); // don't await
        return JSON.parse(cached);
    }
    // First load: fetch and cache
    return await refreshQaTipsCache();
}

async function refreshQaTipsCache() {
    const token = await getAuthToken();
    const url = `${window.location.origin}/${ENDPOINTS.qa_tips}`;
    const options = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };
    const response = await fetch(url,options);
    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(data));
    return data;
}

export async function getBannerQaDrawerContent() {
    const token = await getAuthToken();
    const url = `${window.location.origin}/${ENDPOINTS.qa_drawer}`;
    const options =     {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    };
    const response = await fetch(url,options);
    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
}

// register on click event ope the drawer tips
jQuery("#QA-desktop-detail, #QA-mobile-detail, #QA-chat-progress").on("click", async function() {
  openDrawer();
  toggleQaBaloon(false);
  try {
    const data = await getBannerQaDrawerContent();
    injectDataOnDrawer(data);
    trackEvent("QA_DRAWER_CLICK", "qa drawer click");
  } catch (error) {
    closeDrawer();
    showErrorToast("Si è verificato un errore. Aggiornare la pagina e riprovare");
    throw error;
  }
});

jQuery("#QA-btn").on("click",function(e) {
    e.stopPropagation(); // stop the event so it will not fire the next one and automatically closed the baloon
    toggleQaBaloon(true);
});

jQuery(document).on('click', function () {
    toggleQaBaloon(false);
});

function toggleQaBaloon(state) {
    if(state) {
        jQuery("#QA-baloon").addClass("qa-baloon-active");
        jQuery("#QA-btn").addClass("qa-btn-active");
    } else {
        jQuery("#QA-baloon").removeClass("qa-baloon-active");
        jQuery("#QA-btn").removeClass("qa-btn-active");
    }
}

export function toggleBtnQaDuringChat(state) {
    if(state) {
        jQuery('#QA-btn').addClass("qa-btn-show");
    } else {
        jQuery('#QA-btn').removeClass("qa-btn-show");
    }
}